import { render, staticRenderFns } from "./ClicTableColumnText.vue?vue&type=template&id=6a7757f6&"
import script from "./ClicTableColumnText.vue?vue&type=script&lang=js&"
export * from "./ClicTableColumnText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports